import { Spacing } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import TabBar, { TabContainer } from 'design-system/components/TabBar';

export interface TabView {
  name: string;
  contents: JSX.Element;
  badge?: React.ReactElement;
  disabled?: boolean;
  dataTest?: string;
}

/**
 * TabBar to be used at the top of pages
 */
export const PageTabBar = styled(TabBar)<{ clickable?: boolean }>`
  margin-bottom: ${Spacing[5]};
  ${({ clickable }) =>
    clickable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`;

/**
 * TabContainer used within content such as Cards
 */
export const FloatingTabContainer = styled(TabContainer)<{ clickable?: boolean }>`
  margin-bottom: ${Spacing[4]};
  ${({ clickable }) =>
    clickable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}
`;

export const TabbedSectionContainer = styled('div')`
  width: 100%;
`;
